import { useAppContext } from '@/catalog-apps/hooks/useAppContext'
import { ENDPOINTS } from '@/util'
import { MessagesStorageStorageFileType } from '@/util/enums'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

async function downloadFile({
  url,
  applicationId,
  projectId,
  fileType,
  fileName,
}: {
  url: string
  applicationId?: number
  projectId?: number
  fileType: MessagesStorageStorageFileType
  fileName?: string
}) {
  if (!applicationId || !projectId) {
    throw new Error('Application ID and project ID are required')
  }
  const blobName = url
  const token = JSON.parse(sessionStorage.getItem('token') || '')
  try {
    const response = await fetch(
      `${ENDPOINTS.LANDING}/storage/download_file/${blobName},${applicationId},${projectId},${fileType}`,
      {
        headers: { Authorization: 'Bearer ' + token },
        method: 'GET',
      }
    )
    if (response.ok) {
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.setAttribute('href', url)
      a.setAttribute('download', fileName ?? 'filename.txt')
      document.body.appendChild(a)
      a.click()
      a.remove()
    } else {
      toast.error('Error downloading file')
    }
  } catch (_e) {
    toast.error(`Error downloading file`)
  }
}

export function useDownloadFile() {
  const { appId, projectId } = useAppContext()
  return useMutation({
    mutationFn: ({
      url,
      fileName,
      fileType = MessagesStorageStorageFileType.Template,
    }: {
      url: string
      fileName?: string
      fileType?: MessagesStorageStorageFileType
    }) => downloadFile({ url, applicationId: appId, projectId, fileType, fileName }),
  })
}
